import { render, staticRenderFns } from "./SensorSetting.vue?vue&type=template&id=ba8c721a&scoped=true"
import script from "./SensorSetting.vue?vue&type=script&lang=js"
export * from "./SensorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8c721a",
  null
  
)

export default component.exports